// needs to be synced with
//  - app/models/place.rb
//  - app/frontend/ui/components/mapbox/markers.ts
//  - app/frontend/util/placeCategoryIconMapping.ts
const PlaceCategories = [
  'Food & Drinks',
  'Local Farm / Agricultural',
  'Shopping & Retail',
  'Culture & Recreation',
  'Services',
  'Public Resources',
  'Travel & Lodging',
]

export default PlaceCategories
